import React from 'react';
import { DetailBlock, DetailBlockInput, ValidateErrorMessage } from './StyleUserDetailBlock';
import edit_icon from '../../../images/edit_icon.png';

function RednderInputUserData(elem) {
  return (
    <DetailBlock key={elem.name + elem.value}>
      {elem.title}
      <DetailBlockInput
        image={edit_icon}
        onBlur={elem.changeFunc}
        onFocus={elem.focusFunc}
        onInput={elem.validateChangeFunc}
        max={elem.maxValue}
        min={elem.minValue}
        name={elem.name}
        type="number"
        defaultValue={elem.value}
      />
      {elem.units}
      <ValidateErrorMessage>
        {!elem.isValidate ? elem.validateErrorMessage : ''}
      </ValidateErrorMessage>
    </DetailBlock>
  );
}

export default RednderInputUserData;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/UserDetailBlock/RenderInputUserData.jsx